// @flow
import * as React from 'react';
import LinkButton from '.';

export type Props = {
  url: string,
  children: React.ChildrenArray<*>,
  color: 'primary' | 'flat' | 'blue' | 'orange',
  onLinkClick: ?Function,
  target?: '_blank' | '_self' | '_parent' | '_top',
};

export default class LinkButtonContainer extends React.PureComponent<Props> {
  static defaultProps = {
    target: '_blank',
  };

  constructor(props: Props): void {
    super(props);

    // $FlowFixMe
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e: SyntheticMouseEvent<HTMLLinkElement>): void {
    const { onLinkClick } = this.props;

    if (typeof onLinkClick === 'function') {
      onLinkClick();
      e.preventDefault();
    }
  }

  render(): React.Node {
    return <LinkButton onClick={this.handleClick} {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./app/common/Links/LinkButton/container.js